import "./KeepItemDeadline.scss";
import { useTranslation } from "react-i18next";

/**
 * Asked after an item with a deadline was moved out of a spacer section with
 * a deadline into one without: keep the item's deadline or remove it.
 * Dismissing the modal keeps it.
 */
function KeepItemDeadline({ item, onKeep, onRemove }) {
  const { t, i18n } = useTranslation();
  return (
    <div className="keep-item-deadline-content">
      <div className="modal-title">
        <div>{t("lists.modals.keepDeadline.title")}</div>
      </div>
      <div className="modal-body">
        <p>
          {t("lists.modals.keepDeadline.message", {
            name: item.text,
            date: new Date(item.deadline).toLocaleDateString(i18n.language),
          })}
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button remove" onClick={onRemove}>
          {t("lists.modals.keepDeadline.remove")}
        </button>
        <button className="modal-button keep" onClick={onKeep}>
          {t("lists.modals.keepDeadline.keep")}
        </button>
      </div>
    </div>
  );
}

export default KeepItemDeadline;
